import React, { FC } from 'react';
import { Alert, PageHeader } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PowerBi from 'app/components/PowerBi/PowerBi';
import { useSelector } from 'react-redux';
import {
  selectCompanies,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import { selectPermissionsByCompany } from 'app/containers/Authorization/slice/selectors';
interface IProps {}

const AnalyticsPage: FC<IProps> = props => {
  const { t } = useTranslation();

  const companies = useSelector(selectCompanies);

  const selectedCompanyId = useSelector(selectSelectedCompanyId);

  const { analytics: companiesWithAnalyticsPermission } = useSelector(
    selectPermissionsByCompany,
  );

  const seasonId = useSelector(selectSelectedSeasonId) as number;

  const finalCompanyIds = selectedCompanyId
    ? companiesWithAnalyticsPermission.filter(
        companyId => companyId === selectedCompanyId,
      )
    : companiesWithAnalyticsPermission;

  if (!finalCompanyIds.length) {
    return <NoPermissionsCard />;
  }

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Analytics.Title', 'Analytics')}
      />
      <S.Wrapper>
        {companies.length ? (
          <PowerBi companyIds={finalCompanyIds} seasonId={seasonId} />
        ) : (
          <Alert
            message={t(
              'Analytics.NoCompaniesInEnv',
              "This environment doesn't have any company.",
            )}
            type="info"
          />
        )}
      </S.Wrapper>
    </>
  );
};

const S = {
  Wrapper: styled.div`
    height: calc(100% - 75px);
    background: #e6f7ff;
    .report-style-class {
      height: 100%;
      width: 100%;
    }
  `,
};

export default AnalyticsPage;
